import { UserDetails, deleteEncryptedValue, NavigateConst } from 'common';
import { useContext } from 'react';
import { GlobalContext } from 'context';
import { useUserLogout } from '@sentara-health/sentara-api-hooks-core';
import { endSession } from './Dynatrace';
import { stopOpenReplaySession } from 'common/openreplay/openreplay';

const SignOutHandler = () => {
  const { clearContextValues } = useContext(GlobalContext);
  const { userLogout } = useUserLogout();
  const signOut = async () => {
    await userLogout();
    endSession();
    deleteEncryptedValue();
    document.cookie = UserDetails.optimaPersonCookie + '=';
    document.cookie = UserDetails.optimaRoleCookie + '=';
    const savedLanguage = localStorage.getItem('userLanguagePreference');
    localStorage.clear();
    if (savedLanguage) {
      localStorage.setItem('userLanguagePreference', savedLanguage);
    }
    clearContextValues();
    await stopOpenReplaySession(); 
    window.location.href = NavigateConst.signIn;
  };

  return signOut;
};

export default SignOutHandler;
